import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
// src/components/badge.ts
import { cssVar, defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var baseStyle = defineStyle({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
});
var $bg = cssVar("badge-bg");
var $fg = cssVar("badge-color");
var variantSolid = defineStyle(function (props) {
  var _dark, _ref;
  var c = props.colorScheme,
    theme = props.theme;
  var dark = transparentize("".concat(c, ".500"), 0.6)(theme);
  return _ref = {}, _defineProperty(_ref, $bg.variable, "colors.".concat(c, ".500")), _defineProperty(_ref, $fg.variable, "colors.white"), _defineProperty(_ref, "_dark", (_dark = {}, _defineProperty(_dark, $bg.variable, dark), _defineProperty(_dark, $fg.variable, "colors.whiteAlpha.800"), _dark)), _defineProperty(_ref, "bg", $bg.reference), _defineProperty(_ref, "color", $fg.reference), _ref;
});
var variantSubtle = defineStyle(function (props) {
  var _dark2, _ref2;
  var c = props.colorScheme,
    theme = props.theme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return _ref2 = {}, _defineProperty(_ref2, $bg.variable, "colors.".concat(c, ".100")), _defineProperty(_ref2, $fg.variable, "colors.".concat(c, ".800")), _defineProperty(_ref2, "_dark", (_dark2 = {}, _defineProperty(_dark2, $bg.variable, darkBg), _defineProperty(_dark2, $fg.variable, "colors.".concat(c, ".200")), _dark2)), _defineProperty(_ref2, "bg", $bg.reference), _defineProperty(_ref2, "color", $fg.reference), _ref2;
});
var variantOutline = defineStyle(function (props) {
  var _ref3;
  var c = props.colorScheme,
    theme = props.theme;
  var darkColor = transparentize("".concat(c, ".200"), 0.8)(theme);
  return _ref3 = {}, _defineProperty(_ref3, $fg.variable, "colors.".concat(c, ".500")), _defineProperty(_ref3, "_dark", _defineProperty({}, $fg.variable, darkColor)), _defineProperty(_ref3, "color", $fg.reference), _defineProperty(_ref3, "boxShadow", "inset 0 0 0px 1px ".concat($fg.reference)), _ref3;
});
var variants = {
  solid: variantSolid,
  subtle: variantSubtle,
  outline: variantOutline
};
var badgeTheme = defineStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});
export { badgeTheme };